import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { SyncUserSettingsService } from '@frontend/sports/user/feature';

import { IBetslip } from '../../../../bet-generation/models';
import BetslipSummaryBuilder from '../../../../summary/services/betslip-summary-builder.service';
import { LessStakeAfterTaxPreCheckError } from '../../../errors/pre-check/less-stake-after-tax-pre-check-error';
import { IPureBetslipValidator } from './validators';

@Injectable()
export class LessStakeAfterTaxValidator implements IPureBetslipValidator<LessStakeAfterTaxPreCheckError> {
    constructor(
        private betslipConfig: BetslipConfig,
        private summaryBuilder: BetslipSummaryBuilder,
        private userSettings: SyncUserSettingsService,
    ) {}

    validate(betslip: IBetslip): LessStakeAfterTaxPreCheckError[] {
        if (!this.betslipConfig.allowMultipleSingles || !this.userSettings.isTurnoverTaxApplied) {
            return [];
        }

        const isLessStakeAfterTax = this.checkHasLessStakeAfterTax(betslip);

        return isLessStakeAfterTax ? [new LessStakeAfterTaxPreCheckError()] : [];
    }

    private checkHasLessStakeAfterTax(betslip: IBetslip): boolean {
        const summary = this.summaryBuilder.createBetslipSummaryWithoutTaxation(betslip);

        return summary.slipSummaries.some((slipSummary) => {
            if (!slipSummary.totalStake) {
                return false;
            }

            const winnings = slipSummary.betSummaries
                .map((b) => (b.freeBetWinnings ? b.freeBetWinnings : b.possibleWinnings))
                .reduce((sum, current) => (sum ? (current ? sum.add(current) : sum) : current));

            if (!winnings) {
                return false;
            }

            return winnings.lessThan(slipSummary.totalStake || 0);
        });
    }
}
